import { IDecryptQuestion } from '@/contracts/modules/education/use-case/IDecryptQuestion'
import { IQuestionCipher } from '@/contracts/modules/education/cipher/IQuestionCipher'
import { IQuestionData } from '@/contracts/modules/education/entities/IQuestionData'
import { IUserKey } from '@/contracts/system-modules/auth/key/IUserKey'
import { QuestionCipher } from '@/modules/education/v1/cipher/QuestionCipher'

export class DecryptQuestion implements IDecryptQuestion {
  /** Ключи вопросов после unwrap по ключу пользователя и обёрнутой строке: unwrap делается один раз на ключ */
  private keys = new WeakMap<IUserKey, Map<string, CryptoKey>>()

  constructor(private cipher: IQuestionCipher = new QuestionCipher()) {}

  async exec(key: string, data: string, userKey: IUserKey): Promise<IQuestionData | null> {
    try {
      let cache = this.keys.get(userKey)
      if (cache === undefined) {
        cache = new Map<string, CryptoKey>()
        this.keys.set(userKey, cache)
      }
      let questionKey = cache.get(key)
      if (questionKey === undefined) {
        questionKey = await userKey.unwrap(key)
        cache.set(key, questionKey)
      }
      return await this.cipher.decrypt(questionKey, data)
    } catch {
      return null
    }
  }
}
